import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { ButtonBase, Divider, FormHelperText, Grid, InputAdornment, Tooltip } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import Label from "../../components/Common/Label";
import './order.css'
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import CustomDropDown from "../../components/Common/CustomDropDown";
import CustomIconButton from "../../components/Form/CustomIconButton";
import Table from "../../components/Common/Table";
import CustomTextField from "../../components/Form/CustomTextField";
import CheckBox from "../../components/Form/CheckBox";
import CollectPayment from "./OrderModal/CollectPayment";
import CancelOrder from "./OrderModal/CancellOrder";
import DeleteOrder from "./OrderModal/DeleteOrder";
import ShippedOrder from "./OrderModal/ShippedOrder";
import EditShippedOrder from "./OrderModal/EditShippedOrder";
import RefundOrder from "./OrderModal/RefundOrder";
import DeliverOrder from "./OrderModal/DeliverOrder";
import CloseOrder from "./OrderModal/CloseOrder";
import { Icon } from "@iconify/react/dist/iconify.js";
import UnpaidOrder from "./OrderModal/UnpaidOrder";
import RevertOrder from "./OrderModal/RevertOrder";
import ReopenOrder from "./OrderModal/ReopenOrder";
import InsufficientPointsCancel from "./OrderModal/InsufficientPointsCancel";
import AppDialog from "../../components/Common/AppDialog";
import {
  deleteOrder, downloadInvoice, getOrderDetails, insertLogOrder, markAsPaidOrder, resetOrderAttachmentState, resetOrderState, revertOrderStatus, updateBillingDetailsOrder,
  updateCustomerDetailsOrder, updateOrderCourier, updateOrderStatus, updateShippingDetailsOrder
} from "../../store/actions";
import moment from "moment";
import Helpers from "../../helpers/helpers";
import CustomAutocomplete from "../../components/Form/CustomAutocomplete";

/** Split catalog product names that use <br> between model / specs / warranty lines. */
const productNameLines = (name) => {
  if (!name) return [];
  return String(name)
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/\r\n|\r/g, "\n")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
};

const renderProductLabel = (name, sku, { skuPrefix = "P/N: " } = {}) => {
  const lines = productNameLines(name);
  return (
    <>
      {sku ? <div className="subheader-2 font-size-12">{skuPrefix}{sku}</div> : null}
      {lines.length > 0
        ? lines.map((line, idx) => (
            <div key={idx} className={idx === 0 ? "subheader" : "font-size-14"} style={idx === 0 ? { fontFamily: "Manrope" } : undefined}>
              {line}
            </div>
          ))
        : <div className="subheader" style={{ fontFamily: "Manrope" }}>{name || "N/A"}</div>}
    </>
  );
};

/** Match cart/PO: 1 Premier/KYD → 2 ADP → 3 SB → 4 ISE. */
const warrantyServiceSortRank = (text) => {
  const t = String(text || '').toLowerCase();
  if (/premier\s+support|keep\s+your\s+drive|\bkyd\b/.test(t)) return 1;
  if (/\badp\b|accidental\s+damage/.test(t)) return 2;
  if (/\bsb\b|sealed\s+battery/.test(t)) return 3;
  if (/\bise\b|international\s+services?/.test(t)) return 4;
  return 50;
};

const warrantyServiceSortYears = (text) => {
  const match = String(text || '').match(/(\d+)\s*Years?/i);
  return match ? Number(match[1]) : 0;
};

const sortWarrantyServices = (data) => {
  return [...(data || [])].sort((a, b) => {
    const textA = a?.service_type_name || a?.service_name || '';
    const textB = b?.service_type_name || b?.service_name || '';
    const rankDiff = warrantyServiceSortRank(textA) - warrantyServiceSortRank(textB);
    if (rankDiff !== 0) return rankDiff;
    const yearsDiff = warrantyServiceSortYears(textA) - warrantyServiceSortYears(textB);
    if (yearsDiff !== 0) return yearsDiff;
    return String(textA).localeCompare(String(textB));
  });
};

const ViewOrderAspeed = ({
  title, userPermission, orderDetails, insertLog, updateCustomer, updateBilling,
  updateShipping, paymentTypeList, countryList, markAsPaid, orderDelete, orderUpdateStatus, orderUpdateCourier,
  orderRevertStatus, courier_list, invoiceDocument, shippingMethodList
}) => {
  const dispatch = useDispatch();
  const { ID } = useParams()
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetOrderState());
    return () => {
      dispatch(resetOrderState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getOrderDetails({ id: ID }));
  }, [ID])

  const [loading, setIsLoading] = useState(false);
  const [showRemarkOnFrontend, setShowRemarkOnFrondend] = useState(false);
  const [remark, setRemark] = useState();
  const [status, setStatus] = useState('pending');
  const [orderDetailData, setOrderDetailData] = useState();
  const [collectPaymentOpen, setCollectPaymentOpen] = useState(false);
  const [cancelOrderOpen, setCancelOrderOpen] = useState(false);
  const [deleteOrderOpen, setDeleteOrderOpen] = useState(false);
  const [markDeliveredOpen, setMarkDelieveredOpen] = useState(false);
  const [markClosedOpen, setMarkClosedOpen] = useState(false);
  const [markShippedOpen, setMarkShippedOpen] = useState(false);
  const [editShippingOpen, setEditShippingOpen] = useState(false);
  const [revertStatusOpen, setRevertStatusOpen] = useState(false);
  const [reopenOrderOpen, setReopenOrderOpen] = useState(false);
  const [insufficientPointsOpen, setInsufficientPointsOpen] = useState(false);
  const [pendingCancelReason, setPendingCancelReason] = useState('');
  const [insufficientPointsInfo, setInsufficientPointsInfo] = useState({
    pointsRequired: 0,
    pointsAvailable: 0,
  });
  const [unpaidOrderOpen, setUnpaidOrderOpen] = useState(false);
  const [refundOpen, setRefundOpen] = useState(false);
  const [editCustomerOpen, setEditCustomerOpen] = useState(false);
  const [editShippingAddressOpen, setEditShippingAddressOpen] = useState(false);
  const [editBillingAddressOpen, setEditBillingAddressOpen] = useState(false);
  const [customerData, setCustomerData] = useState({});
  const [shippingData, setShippingData] = useState({});
  const [billingData, setBillingData] = useState({});
  const [shippingSameAsBilling, setShippingSameAsBilling] = useState(false);
  const [isOrderRefunded, setIsOrderRefunded] = useState(false);
  const [isOrderPartiallyRefunded, setOrderPartiallyRefunded] = useState(false);
  const [subtotal, setSubtotal] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [error, setError] = useState();
  const [creatable, setCreatable] = useState(false);
  const [viewable, setViewable] = useState(false);
  const [editable, setEditable] = useState(false);
  const [deletable, setDeletable] = useState(false);
  const [exportable, setExportable] = useState(false);
  const [readyPickupOpen, setReadyPickupOpen] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });

  useEffect(() => {
    if (userPermission?.length > 0) {
      !userPermission?.includes("view-order") && navigate('/not-authorized');
      userPermission?.includes("create-order") && setCreatable(true);
      userPermission?.includes("export-order") && setExportable(true);
      userPermission?.includes("view-order") && setViewable(true);
      userPermission?.includes("edit-order") && setEditable(true);
      userPermission?.includes("delete-order") && setDeletable(true);
    }
  }, [userPermission])

  const pendingOrderDropdown = [
    // { iconName: 'mdi:credit-card-remove-outline', isNotRemixIcon: true, label: 'Mark as unpaid', color: '#282828', onClick: () => setUnpaidOrderOpen(true) },
    { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
    { iconName: 'ri-delete-bin-line', label: 'Delete', color: '#44d62c', permission: deletable, onClick: () => setDeleteOrderOpen(true) },
  ];

  const confirmOrderDropdown = [
    { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => setRefundOpen(true) },
    { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
  ];

  const shippedOrderDropdown = [
    { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => setRefundOpen(true) },
    { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
    { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Revert to confirmed', color: '#282828', permission: editable, onClick: () => setRevertStatusOpen(true) },
  ];

  const deliveredDropdown = [
    { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => setRefundOpen(true) },
    { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
    { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Revert to shipped', color: '#282828', permission: editable, onClick: () => setRevertStatusOpen(true) },
  ];

  const closedOrderDropdown = [
    { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Reopen order', color: '#282828', permission: editable, onClick: () => setReopenOrderOpen(true) },
  ];

  const partiallyRefundedDropdown = [
    { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => setRefundOpen(true) },
  ];

  useEffect(() => {
    if (orderDetails?.code === 'success') {
      let orderTempDetail = orderDetails?.data;
      let subtotal = 0;
      let total_discount = 0;
      let itemAllRefunded = false;
      let itemPartiallyRefunded = false;

      orderTempDetail?.items?.length > 0 && orderTempDetail?.items.map((el, idx) => {
        el.view_specs = false;
        el?.variants?.length > 0 && el.variants.map((variant, idx) => {
          subtotal += (variant?.add_price || 0) * (variant?.quantity || 1);
        })
        el?.addons?.length > 0 && el.addons.map((addon, idx) => {
          subtotal += (addon?.total || 0);
        })
        el?.services?.length > 0 && el?.services.map((service, idx) => {
          subtotal += (service?.price || 0);
        })
        subtotal += el?.total || 0;
        if (orderTempDetail?.status === 'closed') {
          if (el?.refunded_quantity > 0) {
            itemAllRefunded = true;
            itemPartiallyRefunded = true;
          } else {
            itemAllRefunded = false;
          }
        }

      })
      setCustomerData({
        name: orderDetails.data?.customer_name,
        email: orderDetails.data?.customer_email,
        phone: orderDetails.data?.customer_phone,
      })
      setShippingData({
        recipient_name: orderDetails.data?.shipping_name,
        company_name: orderDetails.data?.shipping_company,
        address_line_1: orderDetails.data?.shipping_address_line_1,
        address_line_2: orderDetails.data?.shipping_address_line_2,
        phone: orderDetails.data?.shipping_phone,
        email: orderDetails.data?.shipping_email,
        city: orderDetails.data?.shipping_city,
        postcode: orderDetails.data?.shipping_postal_code,
        country_id: orderDetails.data?.shipping_country_id,
        state: orderDetails.data?.shipping_state
      })
      setBillingData({
        recipient_name: orderDetails.data?.billing_name,
        company_name: orderDetails.data?.billing_company,
        address_line_1: orderDetails.data?.billing_address_line_1,
        address_line_2: orderDetails.data?.billing_address_line_2,
        phone: orderDetails.data?.billing_phone,
        email: orderDetails.data?.billing_email,
        city: orderDetails.data?.billing_city,
        postcode: orderDetails.data?.billing_postal_code,
        country_id: orderDetails.data?.billing_country_id,
        state: orderDetails.data?.billing_state
      })

      orderDetails.data?.applied_promocodes?.length > 0 && orderDetails.data?.applied_promocodes.map((promo, idx) => {
        total_discount += promo?.discount_value;
      })
      orderDetails.data?.applied_vouchers?.length > 0 && orderDetails.data?.applied_vouchers.map((voucher, idx) => {
        total_discount += voucher?.discount_value;
      })

      setIsOrderRefunded(itemAllRefunded);
      setOrderPartiallyRefunded(itemPartiallyRefunded);
      setTotalDiscount(total_discount);
      setSubtotal(subtotal);
      setStatus(orderDetails.data?.status);
      setShippingSameAsBilling(orderDetails.data?.billing_same_as_shipping === 1);
      setOrderDetailData(orderTempDetail);
    }
  }, [orderDetails])

  useEffect(() => {
    if (orderUpdateStatus?.success === true) {
      setCancelOrderOpen(false);
      setMarkShippedOpen(false);
      setReadyPickupOpen(false);
      setMarkDelieveredOpen(false);
      setMarkClosedOpen(false);
      setRefundOpen(false);
      setInsufficientPointsOpen(false);
      setPendingCancelReason('');
      setIsLoading(false);
      setNotification({
        open: true,
        msg: 'Order status update successfully',
        type: 'success'
      })
      dispatch(resetOrderState());
      dispatch(getOrderDetails({ id: ID }));
    } else if (orderUpdateStatus?.success === false) {
      setIsLoading(false);
      if (orderUpdateStatus?.code === 'insufficient_points') {
        setCancelOrderOpen(false);
        setInsufficientPointsInfo({
          pointsRequired: orderUpdateStatus?.points_required ?? 0,
          pointsAvailable: orderUpdateStatus?.points_available ?? 0,
        });
        setInsufficientPointsOpen(true);
        dispatch(resetOrderState());
        return;
      }
      setMarkClosedOpen(false);
      setMarkShippedOpen(false);
      setMarkDelieveredOpen(false);
      setReadyPickupOpen(false);
      setCancelOrderOpen(false);
      setRefundOpen(false);
      setNotification({
        open: true,
        msg: orderUpdateStatus?.message || 'Order status update failed',
        type: 'error'
      })
      dispatch(resetOrderState());
    }
  }, [orderUpdateStatus])

  useEffect(() => {
    if (orderUpdateCourier?.code === 'success') {
      setEditShippingOpen(false);
      setIsLoading(false);
      setNotification({
        open: true,
        msg: 'Order shipping details update successfully',
        type: 'success'
      })
      dispatch(resetOrderState());
      dispatch(getOrderDetails({ id: ID }));
    }
  }, [orderUpdateCourier])

  useEffect(() => {
    if (orderRevertStatus?.success === true) {
      const wasReopen = reopenOrderOpen;
      setRevertStatusOpen(false);
      setReopenOrderOpen(false);
      setIsLoading(false);
      setNotification({
        open: true,
        msg: wasReopen || orderRevertStatus?.status
          ? 'Order reopened successfully'
          : 'Order status reverted',
        type: 'success'
      })
      dispatch(resetOrderState());
      dispatch(getOrderDetails({ id: ID }));
    } else if (orderRevertStatus?.success === false) {
      setReopenOrderOpen(false);
      setNotification({
        open: true,
        msg: orderRevertStatus?.message || 'Order status revert failed',
        type: 'error'
      })
      setIsLoading(false);
      dispatch(resetOrderState());
    }
  }, [orderRevertStatus])

  useEffect(() => {
    if (orderDelete?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Order deleted successfully',
        type: 'success'
      })
      setDeleteOrderOpen(false);
      navigate('/order');
    }
  }, [orderDelete])

  useEffect(() => {
    if (updateCustomer?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Customer details updated successfully',
        type: 'success'
      })
      setEditCustomerOpen(false);
      dispatch(getOrderDetails({ id: ID }));
      setIsLoading(false);
    } else if (updateCustomer?.success === false) {
      setNotification({
        open: true,
        msg: updateCustomer?.message || 'Failed to update customer address',
        type: 'error'
      })
      setError(updateCustomer?.errors);
      setIsLoading(false);
    }
  }, [updateCustomer])

  useEffect(() => {
    if (updateShipping?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Shipping address updated successfully',
        type: 'success'
      })
      setEditShippingAddressOpen(false);
      if (orderDetails.data?.billing_same_as_shipping === 1) {
        let payload = {
          order_id: ID,
          billing_name: shippingData?.recipient_name,
          billing_phone: shippingData?.phone,
          billing_address_line_1: shippingData?.address_line_1,
          billing_address_line_2: shippingData?.address_line_2,
          billing_city: shippingData?.city,
          billing_country_id: shippingData?.country_id,
          billing_state: shippingData?.state,
          billing_postal_code: shippingData?.postcode,
          billing_email: shippingData?.email,
          billing_company: shippingData?.company_name,
          billing_same_as_shipping: 1
        }
        dispatch(updateBillingDetailsOrder(payload));
      } else {
        dispatch(getOrderDetails({ id: ID }));
        setIsLoading(false);
      }
    } else if (updateShipping?.success === false) {
      setNotification({
        open: true,
        msg: updateShipping?.message || 'Failed to update shipping address',
        type: 'error'
      })
      setError(updateShipping?.errors);
      setIsLoading(false);
    }
  }, [updateShipping])

  useEffect(() => {
    if (updateBilling?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Billing address updated successfully',
        type: 'success'
      })
      setEditBillingAddressOpen(false);
      dispatch(getOrderDetails({ id: ID }));
      setIsLoading(false);
    } else if (updateBilling?.success === false) {
      setNotification({
        open: true,
        msg: updateBilling?.message || 'Failed to update billing address',
        type: 'error'
      })
      setError(updateBilling?.errors);
      setIsLoading(false);
    }
  }, [updateBilling])

  useEffect(() => {
    if (markAsPaid?.code === 'success') {
      setNotification({
        open: true,
        msg: 'Order mark as paid successfully',
        type: 'success'
      })
      setCollectPaymentOpen(false);
      dispatch(getOrderDetails({ id: ID }));
      setIsLoading(false);
    }
  }, [markAsPaid])

  useEffect(() => {
    if (insertLog?.code === 'success') {
      setRemark('');
      setNotification({
        open: true,
        msg: 'Remark added successfully',
        type: 'success'
      })
      dispatch(getOrderDetails({ id: ID }));
      setIsLoading(false);
    }
  }, [insertLog])

  useEffect(() => {
    if (invoiceDocument?.code === 'success') {
      const poId = invoiceDocument.invoice_display_id || ID;
      Helpers.handleDownload(invoiceDocument.pdf_base64, `${poId}_po`);
      dispatch(resetOrderAttachmentState());
    } else if (invoiceDocument?.code === 'fail' || invoiceDocument?.code === 'network_error') {
      setNotification({
        open: true,
        msg: invoiceDocument?.message || 'Failed to download Purchase Order',
        type: 'error'
      })
      dispatch(resetOrderAttachmentState());
    }
    setIsLoading(false);
  }, [invoiceDocument])

  useEffect(() => {
    if (shippingSameAsBilling) {
      setBillingData({
        recipient_name: shippingData?.recipient_name,
        company_name: shippingData?.company_name,
        address_line_1: shippingData?.address_line_1,
        address_line_2: shippingData?.address_line_2,
        phone: shippingData?.phone,
        email: shippingData?.email,
        city: shippingData?.city,
        postcode: shippingData?.postcode,
        country_id: shippingData?.country_id,
        state: shippingData?.state
      })
    }
    // else {
    //   setBillingData({
    //     recipient_name: orderDetails.data?.billing_name,
    //     company_name: orderDetails.data?.billing_company,
    //     address_line_1: orderDetails.data?.billing_address_line_1,
    //     address_line_2: orderDetails.data?.billing_address_line_2,
    //     phone: orderDetails.data?.billing_phone,
    //     email: orderDetails.data?.billing_email,
    //     city: orderDetails.data?.billing_city,
    //     postcode: orderDetails.data?.billing_postal_code,
    //     country_id: orderDetails.data?.billing_country_id,
    //     state: orderDetails.data?.billing_state
    //   })
    // }
  }, [shippingSameAsBilling])

  const handleAddRemark = () => {
    if (remark) {
      let payload = {
        order_id: ID,
        // visible_for_customer: showRemarkOnFrontend ? 1 : 0,
        remark: remark
      }
      setIsLoading(true);
      dispatch(insertLogOrder(payload));
    } else {
      setNotification({
        open: true,
        msg: 'Please enter remark',
        type: 'warning'
      })
    }
  }

  const handleMarkOrderAsPaid = (paymentData) => {
    if (paymentData?.payment_type && paymentData?.amount) {
      setIsLoading(true);
      let payload = {
        order_id: ID,
        payment_method_id: paymentData?.payment_type,
        payment_method: paymentTypeList.filter((item) => item.id === paymentData?.payment_type)[0]?.type,
        order_amount: paymentData?.amount
      }
      dispatch(markAsPaidOrder(payload));
    } else {
      setNotification({
        open: true,
        msg: 'Please fill all the fields',
        type: 'warning'
      })
    }
  }

  const handleCancelOrder = (payload, forceWithoutPoints = false) => {
    if (payload) {
      setPendingCancelReason(payload);
      setIsLoading(true);
      let data = {
        id: ID,
        data: {
          status: 'cancelled',
          reason: payload || '-',
          force_cancel_without_points: forceWithoutPoints ? 1 : 0,
        }
      }
      dispatch(updateOrderStatus(data));
    } else {
      setNotification({
        open: true,
        msg: 'Please fill cancellation reason',
        type: 'warning'
      })
    }
  }

  const handleForceCancelWithoutPoints = () => {
    setInsufficientPointsOpen(false);
    handleCancelOrder(pendingCancelReason || '-', true);
  }

  const handleReopenOrder = () => {
    setIsLoading(true);
    dispatch(revertOrderStatus({
      id: ID,
      data: { status: 'reopen' },
    }));
  }

  const handleUnpaidOrder = (payload) => {
    setStatus('payment_failed')
  }

  const handleRevertOrder = (payload) => {
    setIsLoading(true);
    let data = {
      id: ID,
      data: {
        status: payload,
      }
    }
    dispatch(revertOrderStatus(data));
  }

  const handleDeleteOrder = () => {
    dispatch(deleteOrder({ id: ID }));
    setIsLoading(true);
  }

  const handleMarkAsShipped = (payload) => {
    // if (payload?.courier_service && (payload?.tracking_no || payload?.tracking_number) && payload?.tracking_url) {
    setIsLoading(true);
    let data = {
      id: ID,
      data: {
        status: payload?.shipping_method_id === 2 ? 'ready_for_pickup' : 'shipped',
        shipping_method_id: payload.shipping_method_id,
        courier_service: payload?.courier_service,
        tracking_number: payload?.tracking_no || payload?.tracking_number,
        tracking_url: payload?.tracking_url
      }
    }
    dispatch(updateOrderStatus(data));
    // } else {
    //   setNotification({
    //     open: true,
    //     msg: 'Please fill all the fields',
    //     type: 'warning'
    //   })
    // }
  }

  const handleMarkOrderAsReadyForPickup = () => {
    setIsLoading(true);
    let data = {
      id: ID,
      data: {
        status: 'ready_for_pickup',
        // shipping_method_id: payload.shipping_method_id,
      }
    }
    dispatch(updateOrderStatus(data));
  }

  const handleEditShippingDetails = (payload) => {
    if (payload?.courier_service && payload?.tracking_no && payload?.tracking_url) {
      setIsLoading(true);
      let data = {
        id: ID,
        data: {
          shipping_method_id: payload.shipping_method_id,
          courier_service: payload.courier_service,
          tracking_number: payload.tracking_no,
          tracking_url: payload.tracking_url
        }
      }
      dispatch(updateOrderCourier(data));
    } else {
      setNotification({
        open: true,
        msg: 'Please fill all the fields',
        type: 'warning'
      })
    }
  }

  const handleRefund = (refundData) => {
    let verifyPayload = true;
    let addOnList = refundData?.addon_items;

    if (refundData?.refund_amount) {
      let payload = {
        id: ID,
        data: {
          status: 'refunded',
          refund_type: refundData?.refund_type,
          refund_amount: refundData?.refund_amount,
          order_items: []
        }
      }
      if (refundData?.addon_items?.length > 0) { // push the addon item that without refund main product
        let tempAddonList = [];
        refundData?.addon_items.forEach((addon) => {
          if (!tempAddonList?.includes(addon?.order_item_id)) { // to prevent add redundant addon item
            // check if add on item has a main product in refund product array
            const filteredRefundProduct = refundData?.product_refund?.filter(product => addon?.order_item_id === product?.id)?.length === 0 ? refundData?.addon_items?.filter((filter) => filter?.order_item_id === addon?.order_item_id) : null;
            if (filteredRefundProduct?.length > 0) {
              let addonItemList = [];

              addOnList = addOnList.filter((item) => item?.order_item_id !== addon?.order_item_id);
              tempAddonList.push(addon?.order_item_id);

              filteredRefundProduct.map(addon => (
                addonItemList?.filter((el) => el.id === addon?.id)?.length === 0 && addonItemList.push({
                  id: addon.id,
                  quantity: refundData?.addon_items.filter(el => el.id === addon?.id)?.length
                })))

              payload.data.order_items.push({
                id: addon.order_item_id,
                quantity: 0,
                addon_items: addonItemList
              });
            }
          }
        });
      }
      refundData?.product_refund?.length > 0 && refundData?.product_refund.map((item) => {
        if (payload.data.order_items?.filter(el => el.id === item.id)?.length === 0) {
          payload.data.order_items.push({
            id: item.id,
            quantity: refundData?.product_refund.filter(el => el.id === item?.id)?.length,
            addon_items: []
          })
          addOnList?.length > 0 && addOnList.filter((filter) => filter?.order_item_id === item?.id)?.map((addon) => {
            if (payload.data.order_items[payload.data.order_items.length - 1].addon_items?.filter(el => el.id === addon.id)?.length === 0) {
              payload.data.order_items[payload.data.order_items.length - 1].addon_items.push({
                id: addon.id,
                quantity: refundData?.addon_items.filter(el => el.id === addon?.id)?.length
              });
            }
          })
        }
      })
      if (refundData?.product_refund?.length === 0 && refundData?.addon_items?.length === 0) {
        verifyPayload = false;
        setNotification({
          open: true,
          msg: 'Please select items to refund',
          type: 'warning'
        })
      }

      if (verifyPayload) {
        setIsLoading(true);
        dispatch(updateOrderStatus(payload));
      }
    } else {
      setNotification({
        open: true,
        msg: 'Please fill refund amount',
        type: 'warning'
      })
    }

  }

  const handleMarkAsDelivered = () => {
    setIsLoading(true);
    let data = {
      id: ID,
      data: {
        status: 'delivered',
      }
    }
    dispatch(updateOrderStatus(data));
  }

  const handleMarkAsClose = () => {
    setIsLoading(true);
    let data = {
      id: ID,
      data: {
        status: 'closed',
      }
    }
    dispatch(updateOrderStatus(data));
  }

  const handleSaveCardData = (type) => {
    if (type === "customer") {
      let payload = {
        order_id: ID,
        customer_name: customerData?.name,
        customer_email: customerData?.email,
        customer_phone: customerData?.phone
      }
      dispatch(updateCustomerDetailsOrder(payload));
      setIsLoading(true);
    } else if (type === "shipping") {
      let payload = {
        order_id: ID,
        shipping_name: shippingData?.recipient_name,
        shipping_phone: shippingData?.phone,
        shipping_address_line_1: shippingData?.address_line_1,
        shipping_address_line_2: shippingData?.address_line_2,
        shipping_city: shippingData?.city,
        shipping_country_id: shippingData?.country_id,
        shipping_state: shippingData?.state,
        shipping_postal_code: shippingData?.postcode,
        shipping_email: shippingData?.email,
        shipping_company: shippingData?.company_name,
      }
      dispatch(updateShippingDetailsOrder(payload));
      setIsLoading(true);
    } else if (type === "billing") {
      let payload = {
        order_id: ID,
        billing_same_as_shipping: shippingSameAsBilling ? 1 : 0,
        billing_name: shippingSameAsBilling === 1 ? shippingData?.recipient_name : billingData?.recipient_name || '',
        billing_phone: shippingSameAsBilling === 1 ? shippingData?.phone : billingData?.phone || '',
        billing_address_line_1: shippingSameAsBilling === 1 ? shippingData?.address_line_1 : billingData?.address_line_1 || '',
        billing_address_line_2: shippingSameAsBilling === 1 ? shippingData?.address_line_2 : billingData?.address_line_2 || '',
        billing_city: shippingSameAsBilling === 1 ? shippingData?.city : billingData?.city || '',
        billing_country_id: shippingSameAsBilling === 1 ? shippingData?.country_id : billingData?.country_id || '',
        billing_state: shippingSameAsBilling === 1 ? shippingData?.state : billingData?.state || '',
        billing_postal_code: shippingSameAsBilling === 1 ? shippingData?.postcode : billingData?.postcode || '',
        billing_email: shippingSameAsBilling === 1 ? shippingData?.email : billingData?.email || '',
        billing_company: shippingSameAsBilling === 1 ? shippingData?.company_name : billingData?.company_name || '',
      }
      dispatch(updateBillingDetailsOrder(payload));
      setIsLoading(true);
    }
  }

  const handleViewSpecs = (index, field, val) => {
    let tempArr = orderDetailData;
    let tempItemArr = orderDetailData?.items;
    tempItemArr[index][field] = val;
    tempArr.items = tempItemArr;
    setOrderDetailData({ ...tempArr });
  }

  const handleInvoiceDownload = () => {
    let payload = {
      order_id: ID
    }
    dispatch(downloadInvoice(payload));
    setIsLoading(true);
  }

  const editCustomerInfo = () => {
    return (
      <AppDialog
        open={editCustomerOpen}
        close={() => (setEditCustomerOpen(false), handleReset("customer"))}
        titleIcon={'edit'}
        title={'Edit customer information'}
        positiveTitle={'Save Changes'}
        positiveButtonStyle={{ backgroundColor: '#282828', color: 'white', border: '1px solid #282828' }}
        positivePress={() => handleSaveCardData("customer")}
        negativeTitle={'Cancel'}
        negativePress={() => (setEditCustomerOpen(false), handleReset("customer"))}
        width={'30%'}
      >
        {CustomerForm()}
      </AppDialog>
    )
  }

  const editShippingAddressInfo = () => {
    return (
      <AppDialog
        open={editShippingAddressOpen}
        close={() => (setEditShippingAddressOpen(false), handleReset("shipping"))}
        titleIcon={'edit'}
        title={'Edit shipping address'}
        positiveTitle={'Save Changes'}
        positiveButtonStyle={{ backgroundColor: '#282828', color: 'white', border: '1px solid #282828' }}
        positivePress={() => handleSaveCardData("shipping")}
        negativeTitle={'Cancel'}
        negativePress={() => (setEditShippingAddressOpen(false), handleReset("shipping"))}
        width={'50%'}
      >
        {ShippingAddressForm()}
      </AppDialog>
    )
  }

  const editBillingAddressInfo = () => {
    return (
      <AppDialog
        open={editBillingAddressOpen}
        close={() => (setEditBillingAddressOpen(false), handleReset("billing"))}
        titleIcon={'edit'}
        title={'Edit billing address'}
        positiveTitle={'Save Changes'}
        positiveButtonStyle={{ backgroundColor: '#282828', color: 'white', border: '1px solid #282828' }}
        positivePress={() => handleSaveCardData("billing")}
        negativeTitle={'Cancel'}
        negativePress={() => (setEditBillingAddressOpen(false), handleReset("billing"))}
        width={'50%'}
      >
        {BillingAddressForm()}
      </AppDialog>
    )
  }

  const handleReset = (type) => {
    if (type === "billing")
      setBillingData({
        recipient_name: orderDetails.data?.billing_name,
        company_name: orderDetails.data?.billing_company,
        address_line_1: orderDetails.data?.billing_address_line_1,
        address_line_2: orderDetails.data?.billing_address_line_2,
        phone: orderDetails.data?.billing_phone,
        email: orderDetails.data?.billing_email,
        city: orderDetails.data?.billing_city,
        postcode: orderDetails.data?.billing_postal_code,
        country_id: orderDetails.data?.billing_country_id,
        state: orderDetails.data?.billing_state
      })
    else if (type === "shipping")
      setShippingData({
        recipient_name: orderDetails.data?.shipping_name,
        company_name: orderDetails.data?.shipping_company,
        address_line_1: orderDetails.data?.shipping_address_line_1,
        address_line_2: orderDetails.data?.shipping_address_line_2,
        phone: orderDetails.data?.shipping_phone,
        email: orderDetails.data?.shipping_email,
        city: orderDetails.data?.shipping_city,
        postcode: orderDetails.data?.shipping_postal_code,
        country_id: orderDetails.data?.shipping_country_id,
        state: orderDetails.data?.shipping_state
      })
    else if (type === "customer")
      setCustomerData({
        name: orderDetails.data?.customer_name,
        email: orderDetails.data?.customer_email,
        phone: orderDetails.data?.customer_phone,
      })

  }

  const handleValueChange = (dataObj, field, val, setDataObj) => {
    setDataObj(prevState => ({ ...prevState, [field]: val }));
  }

  const CustomerForm = () => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Name'}
              values={customerData?.name}
              placeholder={'Please select'}
              onChange={(e) => {
                handleValueChange(customerData, 'name', e, setCustomerData)
              }}
              error={error?.customer_name?.length && error?.customer_name[0]}
            />
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Email address'}
              values={customerData?.email}
              placeholder={'customer.email@example.com'}
              onChange={(e) => {
                handleValueChange(customerData, 'email', e, setCustomerData)
              }}
              error={error?.customer_email?.length > 0 ? error?.customer_email[0] : customerData?.email && !Helpers.emailValidation(customerData?.email) ? '' : 'Invalid email address'}
            />
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Phone number'}
              values={customerData?.phone}
              type={'phone'}
              placeholder={'65123456789'}
              onChange={(e) => {
                handleValueChange(customerData, 'phone', e, setCustomerData)
              }}
              error={error?.customer_phone?.length && error?.customer_phone[0]}
            />
          </Grid>
        </Grid>
      </>
    )
  }

  const ShippingAddressForm = () => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Recipient name'}
              values={shippingData?.recipient_name}
              placeholder={'Recipient name'}
              onChange={(e) => {
                handleValueChange(shippingData, 'recipient_name', e, setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'recipient_name', e, setBillingData);
              }}
            />
            <FormHelperText>Complete name of the person receiving the order</FormHelperText>
            {error?.shipping_name?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.shipping_name[0] || ""}</FormHelperText>}
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Company name (optional)'}
              values={shippingData?.company_name}
              placeholder={'Company name'}
              onChange={(e) => {
                handleValueChange(shippingData, 'company_name', e, setShippingData);
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'company_name', e, setBillingData);
              }}
              error={error?.shipping_company?.length && error?.shipping_company[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'Email address'}
              values={shippingData?.email}
              placeholder={'customer.email@example.com'}
              onChange={(e) => {
                handleValueChange(shippingData, 'email', e, setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'email', e, setBillingData);
              }}
              error={error?.shipping_email?.length && error?.shipping_email[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'Phone number'}
              values={shippingData?.phone}
              type={'phone'}
              placeholder={'65123456789'}
              onChange={(e) => {
                handleValueChange(shippingData, 'phone', e, setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'phone', e, setBillingData);
              }}
              error={error?.shipping_phone?.length && error?.shipping_phone[0]}
            />
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Address line 1'}
              values={shippingData?.address_line_1}
              placeholder={'Block number, street name'}
              onChange={(e) => {
                handleValueChange(shippingData, 'address_line_1', e, setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'address_line_1', e, setBillingData);
              }}
              error={error?.shipping_address_line_1?.length && error?.shipping_address_line_1[0]}
            />
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Address line 2'}
              values={shippingData?.address_line_2}
              placeholder={'Unit number, building name'}
              onChange={(e) => {
                handleValueChange(shippingData, 'address_line_2', e, setShippingData);
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'address_line_2', e, setBillingData);
              }}
              error={error?.shipping_address_line_2?.length && error?.shipping_address_line_2[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomAutocomplete
              title={'Country'}
              valueName={"id"}
              labelName={"name"}
              values={shippingData?.country_id || '-1'}
              placeholder={'Country'}
              onChange={(e, value) => {
                handleValueChange(shippingData, 'country_id', value?.id || '', setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'country_id', value?.id || '', setBillingData);
              }}
              data={countryList || []}
            />
            {error?.shipping_country_id?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.shipping_country_id[0] || ""}</FormHelperText>}
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'City'}
              values={shippingData?.city}
              placeholder={'City'}
              onChange={(e) => {
                handleValueChange(shippingData, 'city', e, setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'city', e, setBillingData);
              }}
              error={error?.shipping_city?.length && error?.shipping_city[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'State / province / region (optional)'}
              values={shippingData?.state}
              placeholder={'State / province / region'}
              onChange={(e) => {
                handleValueChange(shippingData, 'state', e, setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'state', e, setBillingData);
              }}
              error={error?.shipping_state?.length && error?.shipping_state[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'Postal code'}
              values={shippingData?.postcode}
              type={'phone'}
              placeholder={'6-digit postal code'}
              onChange={(e) => {
                handleValueChange(shippingData, 'postcode', e, setShippingData)
                if (shippingSameAsBilling)
                  handleValueChange(billingData, 'postcode', e, setBillingData);
              }}
              error={error?.shipping_postal_code?.length && error?.shipping_postal_code[0]}
            />
          </Grid>
          <Grid item sm={12} md={12} p={6}></Grid>
        </Grid>
      </>
    )
  }

  const BillingAddressForm = () => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item sm={12} md={12}>
            <CheckBox
              label={'Same as shipping address'}
              values={shippingSameAsBilling}
              onChange={(e) => setShippingSameAsBilling(e.target.checked)}
            />
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Recipient name'}
              values={billingData?.recipient_name}
              placeholder={'Recipient name'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'recipient_name', e, setBillingData)
              }}
            />
            <FormHelperText>Complete name of the person receiving the order</FormHelperText>
            {error?.billing_name?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.billing_name[0] || ""}</FormHelperText>}
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Company name (optional)'}
              values={billingData?.company_name}
              placeholder={'Company name'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'company_name', e, setBillingData)
              }}
              error={error?.billing_company?.length && error?.billing_company[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'Email address'}
              values={billingData?.email}
              placeholder={'customer.email@example.com'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'email', e, setBillingData)
              }}
              error={error?.billing_email?.length && error?.billing_email[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'Phone number'}
              values={billingData?.phone}
              type={'phone'}
              placeholder={'65123456789'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'phone', e, setBillingData)
              }}
              error={error?.billing_phone?.length && error?.billing_phone[0]}
            />
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Address line 1'}
              values={billingData?.address_line_1}
              placeholder={'Block number, street name'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'address_line_1', e, setBillingData)
              }}
              error={error?.billing_address_line_1?.length && error?.billing_address_line_1[0]}
            />
          </Grid>
          <Grid item sm={12} md={12}>
            <CustomTextField
              title={'Address line 2'}
              values={billingData?.address_line_2}
              placeholder={'Unit number, building name'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'address_line_2', e, setBillingData)
              }}
              error={error?.billing_address_line_2?.length && error?.billing_address_line_2[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomAutocomplete
              title={'Country'}
              valueName={"id"}
              labelName={"name"}
              values={billingData?.country_id || '-1'}
              placeholder={'Country'}
              onChange={(e, value) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'country_id', value?.id || '', setBillingData)
              }}
              data={countryList || []}
            />
            {error?.billing_country_id?.length > 0 && <FormHelperText sx={{ color: "red" }}>{error.billing_country_id[0] || ""}</FormHelperText>}
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'City'}
              values={billingData?.city}
              placeholder={'City'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'city', e, setBillingData)
              }}
              error={error?.billing_city?.length && error?.billing_city[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'State / province / region (optional)'}
              values={billingData?.state}
              placeholder={'State / province / region'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'state', e, setBillingData)
              }}
              error={error?.billing_state?.length && error?.billing_state[0]}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <CustomTextField
              title={'Postal code'}
              values={billingData?.postcode}
              type={'phone'}
              placeholder={'6-digit postal code'}
              onChange={(e) => {
                if (shippingSameAsBilling) setShippingSameAsBilling(false);
                handleValueChange(billingData, 'postcode', e, setBillingData)
              }}
              error={error?.billing_postal_code?.length && error?.billing_postal_code[0]}
            />
          </Grid>
        </Grid>
      </>

    )
  }

  const renderHeader = () => {
    return (
      <Grid container>
        <Grid item xs={12} sm={6} md={6} lg={6} display={'flex'} alignItems={'center'}>
          <Link to={"/order"}>
            <CustomButton
              title={<i className="ri-arrow-left-line" style={{ fontSize: 20 }} />}
              press={() => ""}
              backgroundColor={'transparent'}
              textColor={'#999999'}
              borderStyle={"1px solid #D0D0D0"}
              paddingInline={12}
              padding={5}
            />
          </Link>
          <div style={{ fontSize: 24, marginLeft: 10 }}>Order <span className="header">#{orderDetailData?.invoice_display_id || ID}</span></div>
        </Grid>
        {
          orderDetailData?.status !== 'payment_failed' &&
          <Grid item xs={12} sm={6} md={6} lg={6} display={'flex'} alignItems={'center'} justifyContent={'end'} sx={{ justifyContent: { lg: 'end', sm: 'end', xs: 'start' }, marginTop: { lg: 0, xs: 1 } }}>
            <CustomButton
              title={<div className="d-flex align-items-center"><Icon icon={'mdi:invoice-text-outline'} fontSize={16} className="me-1" /> PO</div>}
              press={() => handleInvoiceDownload()}
              borderStyle={'1px solid #D0D0D0'}
              textColor={'#282828'}
              marginRight={10}
            />
            {
              editable &&
              <RenderActionButton
                title={(
                  orderDetailData?.status === 'pending' || orderDetailData?.status === 'payment_failed') ? 'Mark as paid' :
                  orderDetailData?.status === 'ordered' ? `${orderDetailData?.shipping_method_id === 2 ? "Mark as Ready for Pickup" : 'Mark as shipped'}` :
                    orderDetailData?.status === 'shipped' ? 'Mark as delivered' :
                      orderDetailData?.status === 'closed' || orderDetailData?.status === 'cancelled' ? null :
                        'Close order'
                }
                setOpen={(
                  orderDetailData?.status === 'pending' || orderDetailData?.status === 'payment_failed') ? setCollectPaymentOpen :
                  orderDetailData?.status === 'ordered' ? orderDetailData?.shipping_method_id === 2 ? setReadyPickupOpen : setMarkShippedOpen :
                    orderDetailData?.status === 'shipped' ? setMarkDelieveredOpen :
                      orderDetailData?.status === 'closed' ? null :
                        setMarkClosedOpen
                }
              />
            }
            {
              (editable || (orderDetailData?.status === 'pending' && deletable)) &&
              <RenderOptionsButton
                dropdownList={
                  orderDetailData?.status === 'pending' ? pendingOrderDropdown :
                    orderDetailData?.status === 'ordered' ? confirmOrderDropdown :
                      orderDetailData?.status === 'shipped' || orderDetailData?.status === 'ready_for_pickup' ? shippedOrderDropdown :
                        orderDetailData?.status === 'delivered' ? deliveredDropdown :
                          orderDetailData?.status === 'closed' ? closedOrderDropdown :
                            // orderDetailData?.status === 'cancelled' ? cancelledDropdown :
                            orderDetailData?.status === 'partially_refunded' ? partiallyRefundedDropdown :
                              null
                }
              />
            }
          </Grid>
        }
      </Grid>
    )
  }

  const renderOrderInfoAttr = (attr, val) => {
    return (
      <Grid container className="d-flex mt-1 align-items-center">
        <Grid item md={5} sm={12} xs={12} className="subheader-2">{attr}:</Grid>
        <Grid item md={7} sm={12} xs={12}>{val}</Grid>
      </Grid>
    )
  }

  const renderOrderInfo = () => {
    return (
      <Card className="p-3 mt-4">
        <CardBody>
          <div className="header-2 d-flex" style={{ flexWrap: 'wrap' }}>
            <div>Order #{orderDetailData?.invoice_display_id || ID}</div>
            {isOrderRefunded && isOrderPartiallyRefunded && <Label.OrderLabel label={'refunded'} />}
            {isOrderPartiallyRefunded && !isOrderPartiallyRefunded && <Label.OrderLabel label={'partially_refunded'} />}
            <Label.OrderLabel label={orderDetailData?.status || 'pending'} />
          </div>
          <Grid container className="d-flex mt-3" spacing={1}>
            <Grid item lg={3} xs={12}><span className="text-semibold">Platform: </span> Aventrix Ecommerce Platform</Grid>
            <Grid item lg={3} xs={12}><span className="text-semibold">Placed on: </span> {orderDetailData?.placed_on || '-'}</Grid>
            <Grid item lg={3} xs={12}><span className="text-semibold">Paid on: </span> {orderDetailData?.payment_made || '-'}</Grid>
            <Grid item lg={3} xs={12}><span className="text-semibold">Last modified: </span> {orderDetailData?.last_modified || '-'}</Grid>
          </Grid>
          <Divider className="mt-3" />
          <Grid container columnSpacing={2}>
            <Grid className="mt-4 w-100" item lg={4} md={12} sm={12} >
              <div className="curve-container">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="mb-2 text-bold">Customer Information</div>
                  {
                    (orderDetailData?.status === 'pending' || orderDetailData?.status === 'ordered' || orderDetailData?.status === 'shipped') && editable &&
                    <CustomIconButton
                      iconName={'ri-pencil-line'}
                      onClick={() => { setEditCustomerOpen(true) }}
                    />
                  }
                </div>
                {renderOrderInfoAttr('Name', orderDetails.data?.customer_name || 'N/A')}
                {renderOrderInfoAttr('Email address', orderDetails.data?.customer_email || 'N/A')}
                {renderOrderInfoAttr('Phone number', orderDetails.data?.customer_phone || 'N/A')}
              </div>
            </Grid>
            <Grid className="mt-4 w-100" item lg={4} md={12} sm={12}>
              <div className="curve-container">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="mb-2 text-bold">Shipping Address</div>
                  {
                    (orderDetailData?.status === 'pending' || orderDetailData?.status === 'ordered' || orderDetailData?.status === 'shipped') && editable &&
                    <CustomIconButton
                      iconName={'ri-pencil-line'}
                      onClick={() => { setEditShippingAddressOpen(true) }}
                    />
                  }
                </div>
                {renderOrderInfoAttr('Recipient name', orderDetails.data?.shipping_name || 'N/A')}
                {renderOrderInfoAttr('Company', orderDetails.data?.shipping_company || 'N/A')}
                {renderOrderInfoAttr('Address', (orderDetails.data?.shipping_address_line_1 || "") + "" + (orderDetails.data?.billing_address_line_2 || ""))}
                {renderOrderInfoAttr('Phone number', orderDetails.data?.shipping_phone || 'N/A')}
              </div>
            </Grid>
            <Grid className="mt-4 w-100" item lg={4} md={12} sm={12} >
              <div className="curve-container">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="mb-2 text-bold">Billing Address</div>
                  {
                    (orderDetailData?.status === 'pending' || orderDetailData?.status === 'ordered' || orderDetailData?.status === 'shipped') && editable &&
                    <CustomIconButton
                      iconName={'ri-pencil-line'}
                      onClick={() => { setEditBillingAddressOpen(true) }}
                    />
                  }
                </div>
                {
                  orderDetails.data?.billing_same_as_shipping ?
                    <div>Same as shipping address</div>
                    :
                    <>
                      {renderOrderInfoAttr('Recipient name', orderDetails.data?.billing_name || 'N/A')}
                      {renderOrderInfoAttr('Company', orderDetails.data?.billing_company || 'N/A')}
                      {renderOrderInfoAttr('Address', (orderDetails.data?.billing_address_line_1 || "") + "" + (orderDetails.data?.billing_address_line_2 || ""))}
                      {renderOrderInfoAttr('Phone number', orderDetails.data?.billing_phone || 'N/A')}
                    </>
                }
              </div>
            </Grid>
          </Grid>

        </CardBody>
      </Card>
    )
  }

  const renderItemOrdered = (itemData, index) => {
    return (
      <div >
        <div style={{ flexDirection: 'row', display: 'flex', width: '100%', paddingBlock: 10 }}>
          <div style={{ width: '8%' }}><img src={itemData?.product_thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 58, maxWidth: '100%', objectFit: 'contain' }} /></div>
          <div style={{ width: '48%', marginLeft: 10 }}>
            <div className="d-flex align-items-start flex-column">
              {renderProductLabel(itemData?.product_name, itemData?.sku)}
              <div className="d-flex align-items-center mt-1">
                <Label.ItemTag label={itemData?.product_type} />
                {itemData?.refunded_quantity > 0 && (itemData?.quantity - itemData?.refunded_quantity) === 0 && <Label.RefundedLabel />}
                {itemData?.refunded_quantity > 0 && (itemData?.quantity - itemData?.refunded_quantity) > 0 && <Label.OrderLabel label={'partially_refunded'} />}
              </div>
            </div>
          </div>
          <div style={{ width: '24%', textAlign: 'right' }}>
            <div> S$ {Number((itemData?.subtotal / itemData.quantity || 0) - (itemData?.discount_amount / itemData.quantity || 0)).toFixed(2)}</div>
            {itemData?.discount_amount !== 0 && <div style={{ textDecorationLine: 'line-through', color: '#999999' }}> S$ {itemData?.subtotal && Number(itemData?.subtotal / itemData.quantity).toFixed(2)}</div>}
          </div>
          <div style={{ width: '10%', textAlign: 'right' }}>X{itemData?.quantity || '0'}</div>
          <div style={{ width: '10%', textAlign: 'right' }}>S$ {itemData?.total && Number(itemData.total).toFixed(2)}</div>
        </div>
        {
          itemData?.variants?.length > 0 &&
          <div className="my-3" style={{ width: '100%' }}>
            <div className="clickable-text" onClick={() => handleViewSpecs(index, 'view_specs', !itemData?.view_specs)}>
              {!itemData?.view_specs ? 'View Specs' : 'Hide Specs'}
            </div>
            {
              itemData?.view_specs &&
              <div className="mt-1 mb-2" style={{ color: '#686868', fontSize: 12 }}>
                {
                  itemData?.variants.map((variant, idx) => {
                    return (
                      <li>
                        <span style={{ fontFamily: 'Manrope-Bold' }}>{variant?.configuration_text}</span>: {variant?.quantity > 1 && <span>{variant.quantity}x</span>} {variant?.configuration_item_text}
                        {variant?.add_price > 0 && <span style={{ color: '#44d62c', fontFamily: 'Manrope-Bold' }}>(+S$ {variant.add_price * (variant.quantity || 1)})</span>}
                      </li>
                    )
                  })
                }
              </div>
            }
          </div>
        }
        {/* start loop add on item */}
        {itemData?.addons?.length > 0 && renderItemAddOn(itemData.addons)}
        {itemData?.gifts?.length > 0 && renderItemGift(itemData.gifts)}
        {itemData?.services?.length > 0 && renderItemService(itemData.services, itemData?.product_thumbnail)}
        {/* end loop ordered item */}
        <Divider className="my-3" />
      </div>
    )
  }

  const renderItemService = (data, productThumbnail) => {
    const sorted = sortWarrantyServices(data);

    return (
      <>
        <div style={{ paddingTop: 10 }}>
          <div className="text-bold py-0 my-2" style={{ width: '100%', fontSize: 13, textAlign: 'left' }}>
            {`Service & Warranty`}
          </div>
        </div>
        {
          sorted.map((item, idx) => {
            const lines = productNameLines(item?.service_type_name || item?.service_name || '');
            const imageSrc = item?.image || productThumbnail || Helpers.noImageLink;
            return (
              <div key={item?.id || idx} style={{ width: '100%', paddingBlock: 6 }} className="mt-1 d-flex align-items-center">
                <div style={{ width: '8%' }}>
                  <img
                    src={imageSrc}
                    alt="service"
                    style={{ height: 58, maxWidth: '100%', objectFit: 'contain' }}
                  />
                </div>
                <div style={{ width: '48%', marginLeft: 10 }}>
                  {lines.length > 0
                    ? lines.map((line, lineIdx) => (
                        <div
                          key={lineIdx}
                          className={lineIdx === 0 ? "subheader" : "font-size-14"}
                          style={lineIdx === 0 ? { fontFamily: "Manrope" } : undefined}
                        >
                          {line}
                        </div>
                      ))
                    : <div className="font-size-14">-</div>}
                  {item?.sku ? (
                    <div className="subheader-2 font-size-12">P/N: {item.sku}</div>
                  ) : null}
                </div>
                <div style={{ width: '24%' }}></div>
                <div style={{ width: '10%', textAlign: 'right' }}>X{item?.quantity || '1'}</div>
                <div style={{ width: '10%', textAlign: 'right' }}>S$ {Number(item?.price || 0).toFixed(2)}</div>
              </div>
            )
          })
        }
      </>
    )
  }
  const renderItemAddOn = (data) => {
    return (
      <>
        <div className="text-bold py-0 my-2" style={{ width: '100%', fontSize: 13, textAlign: 'left' }}>
          {`Add On (${data?.length || '0'} ${data?.length > 1 ? 'items' : 'item'})`}
        </div>
        {
          data?.length > 0 && data.map((item, idx) => {
            return (
              <div style={{ width: '100%' }} className="mt-1 d-flex">
                <div style={{ width: '56%' }}>
                  <div className="font-size-14 d-flex align-items-start flex-column">
                    {renderProductLabel(item?.product_name, item?.product_sku, { skuPrefix: 'SKU: ' })}
                    <div className="d-flex align-items-center mt-1">
                      {item?.refunded_quantity > 0 && (item?.quantity - item?.refunded_quantity) === 0 && <Label.RefundedLabel height={'20px'} />}
                      {item?.refunded_quantity > 0 && (item?.quantity - item?.refunded_quantity) > 0 && <Label.OrderLabel label={'partially_refunded'} height={'20px'} />}
                    </div>
                  </div>
                </div>
                <div style={{ width: '24%', textAlign: 'right' }}>
                  <div> S$ {Number((item?.price || 0) - (item?.discount_amount || 0)).toFixed(2)}</div>
                  {!Helpers.isNullOrEmpty(item?.discount_amount) && <div style={{ textDecorationLine: 'line-through', color: '#999999' }}> S$ {item?.price && Number(item?.price).toFixed(2)}</div>}
                </div>
                <div style={{ width: '10%', textAlign: 'right' }}>X{item?.quantity || '0'}</div>
                <div style={{ width: '10%', textAlign: 'right' }}>S$ {Number((item?.total || 0)).toFixed(2)}</div>
              </div>
            )
          })
        }
      </>
    )
  }
  const renderItemGift = (data) => {
    return (
      <>
        <div style={{ paddingTop: 10 }}>
          <div className="text-bold py-0 my-2" style={{ width: '100%', fontSize: 13, textAlign: 'left' }}>
            {`Free Gift (${data?.length || '0'} ${data?.length > 1 ? 'items' : 'item'})`}
          </div>
        </div>
        <div style={{}}>
          {
            data?.length > 0 && data.map((item, idx) => {
              return (
                <div style={{ width: '100%' }} className="mt-1 d-flex">
                  <div style={{ width: '56%' }}>
                    {renderProductLabel(item?.product_name, item?.sku, { skuPrefix: 'SKU: ' })}
                  </div>
                  <div style={{ width: '24%' }}></div>
                  <div style={{ width: '10%', textAlign: 'right' }}>X{item?.quantity || '0'}</div>
                  <div style={{ width: '10%', textAlign: 'right' }}>FREE</div>
                </div>
              )
            })
          }
        </div>
      </>
    )
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <LoadingDialog open={loading || !orderDetails?.data} />
        {editCustomerInfo()}
        {editShippingAddressInfo()}
        {editBillingAddressInfo()}
        <Notification notification={notification} setNotification={setNotification} />
        <Container fluid>
          {renderHeader()}
          {renderOrderInfo()}
          <Card className="p-3 mt-4">
            <CardBody>
              <div className="header-2">Item Ordered</div>
              <Divider className="mt-2 mb-3" />
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <div style={{ flexDirection: 'row', display: 'flex', paddingTop: 10, minWidth: 800 }}>
                  <div className="subheader" style={{ width: '56%' }}>Item Name</div>
                  <div className="subheader" style={{ width: '24%', textAlign: 'right' }}>Price</div>
                  <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>Quantity</div>
                  <div className="subheader" style={{ width: '10%', textAlign: 'right' }}>Total</div>
                </div>
                <div style={{ minWidth: 800 }}>
                  <Divider className="my-3" />
                  {orderDetailData?.items?.length > 0 && orderDetailData?.items?.map((item, idx) => {
                    return (
                      renderItemOrdered(item, idx)
                    )
                  })}
                </div>
                <div className="d-flex align-items-center">{orderDetailData?.payment_method || "-"} <Label.PaymentStatusLabel label={orderDetailData?.is_paid === 0 ? 'Unpaid' : 'Paid'} /></div>
                <Divider className="my-3" />
              </div>
              <Grid container textAlign={'right'} spacing={1} mt={2}>
                <Grid item md={6} sm={6} xs={6} textAlign={'left'}>Subtotal</Grid>
                <Grid item md={6} sm={6} xs={6}>S$ {Number(subtotal).toFixed(2) || '0.00'}</Grid>
                <Grid item md={10} sm={8} xs={8} textAlign={'left'} display={'flex'}>
                  Discount
                  {
                    orderDetailData?.applied_promocodes &&
                    <div style={{ color: '#999999', display: 'flex', flexWrap: 'wrap' }}>
                      <i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{orderDetailData.applied_promocodes}
                    </div>
                  }
                  {
                    orderDetailData?.applied_vouchers &&
                    <div style={{ color: '#999999', display: 'flex', flexWrap: 'wrap' }}>
                      <i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{orderDetailData.applied_vouchers}
                    </div>
                  }
                  {/* {
                    (orderDetailData?.applied_promocodes?.length > 0 || orderDetailData?.applied_vouchers?.length > 0) &&
                    <div style={{ color: '#999999', display: 'flex', flexWrap: 'wrap' }}>
                      {
                        orderDetailData?.applied_promocodes?.length > 0 && orderDetailData?.applied_promocodes?.map((promo, idx) => {
                          return (
                            <><i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{promo?.code}</>
                          )
                        })
                      }
                      {
                        orderDetailData?.applied_vouchers?.length > 0 && orderDetailData?.applied_vouchers?.map((voucher, idx) => {
                          return (
                            <><i className="ri-price-tag-3-line" style={{ marginLeft: 10, marginRight: 3 }} />{voucher?.caption}</>
                          )
                        })
                      }
                    </div>
                  } */}
                </Grid>
                <Grid item md={2} sm={4} xs={4}>-S$ {orderDetailData?.discount_amount ? Number(orderDetailData?.discount_amount).toFixed(2) : '0.00'}</Grid>
                <Grid item md={6} sm={6} xs={6} textAlign={'left'}>Shipping {orderDetailData?.shipping_method_name ? `- ${orderDetailData.shipping_method_name}` : ''}</Grid>
                <Grid item md={6} sm={6} xs={6}>{orderDetailData?.shipping_fee == (0 || 0.00) ? 'FREE' : `S$${Number(orderDetailData?.shipping_fee).toFixed(2)}`}</Grid>
                {orderDetails?.points_enabled !== false && (
                  <>
                    <Grid item md={6} sm={6} xs={6} textAlign={'left'}>Points Earned <Tooltip title={'Points are awarded when the order is closed. Cancelling after that returns those points.'} className="mx-1" placement="top"><i className="ri-information-line" /></Tooltip></Grid>
                    <Grid item md={6} sm={6} xs={6}>{
                      Number(orderDetailData?.earned_points_given || 0) > 0
                        ? `${Number(orderDetailData.earned_points_given)} points`
                        : (['cancelled', 'payment_failed'].includes(orderDetailData?.status)
                          ? '0 points'
                          : `${Number(orderDetailData?.earned_points || 0)} points (pending close)`)
                    }</Grid>
                  </>
                )}
                <Grid item md={6} sm={6} xs={6} className="text-bold" textAlign={'left'} >Total</Grid>
                <Grid item md={6} sm={6} xs={6} className="text-bold">S$ {Number(orderDetailData?.order_amount || 0).toFixed(2)}</Grid>
              </Grid>
            </CardBody>
          </Card>
          {
            (orderDetailData?.status !== 'pending' && orderDetailData?.status !== 'cancelled' && orderDetailData?.status !== 'payment_failed') &&
            <Card className="p-3 mt-4">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="header-2">Shipping Details</div>
                  {
                    (orderDetailData?.status === 'ordered' || orderDetailData?.status === 'shipped') && editable &&
                    <CustomIconButton
                      iconName={'ri-pencil-line'}
                      onClick={() => { setEditShippingOpen(true) }}
                    />
                  }
                </div>
                <Divider className="my-3" />
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={3} md={3} >
                    <div style={{ color: '#686868' }}>Shipping method</div>
                    <div className="mt-2">{orderDetailData?.shipping_method_name || 'N/A'}</div>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} >
                    <div style={{ color: '#686868' }}>Courier service</div>
                    <div className="mt-2">{orderDetailData?.courier_service_label || orderDetailData?.courier_service || 'N/A'}</div>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <div style={{ color: '#686868' }}>Tracking number</div>
                    <div className="mt-2">{orderDetailData?.tracking_number || 'N/A'}</div>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <div style={{ color: '#686868', marginBottom: 8 }}>Tracking URL</div>
                    {
                      orderDetailData?.tracking_url ?
                        <a className="clickable-text" href={`//${orderDetailData?.tracking_url}`} target="_blank" rel="noopener noreferrer">{orderDetailData?.tracking_url || 'N/A'}</a> :
                        <>N/A</>
                    }
                  </Grid>
                </Grid>
              </CardBody>
            </Card>
          }
          {
            (orderDetailData?.status === 'refunded' || orderDetailData?.status === 'partially_refunded' || orderDetailData?.status === 'closed') && orderDetailData?.inquiries?.length > 0 &&
            <Card className="p-3 mt-4">
              <CardBody>
                <div className="header-2">Refund Details</div>
                <Divider className="my-3" />
                <Grid container spacing={2}>

                  {/* if refund preference = refund then show refund amount, other preference is refund or store_credit */}
                  <Grid item sm={3} xs={5} className="subheader-3">Refund amount</Grid>
                  <Grid item sm={9} xs={7} className="text-bold">
                    S${orderDetailData?.total_refunded || '0.00'}
                  </Grid>

                  {/* start loop returned item */}
                  <Grid item container sm={12} spacing={2} mt={1}>
                    <Grid item sm={12} xs={12} className="text-bold">Selected products ({orderDetailData?.inquiries?.length || '0'})<Divider className="my-3" /></Grid>
                  </Grid>
                  {
                    orderDetailData?.inquiries?.length > 0 && orderDetailData?.inquiries?.map((item, idx) => {
                      return (
                        <Grid item container sm={12} spacing={2} mb={2}>
                          <Grid item sm={3} xs={12} className="subheader-3">Refund preference</Grid>
                          <Grid item sm={9} xs={12} className="text-bold">{item?.return_preference || '-'}</Grid>
                          <Grid item sm={3} xs={12} className="subheader-3">Preferred refund method</Grid>
                          <Grid item sm={9} xs={12} className="subheader">{'-'}</Grid>
                          <Grid item sm={3} xs={12} className="subheader-3">Additional details</Grid>
                          <Grid item sm={9} xs={12} className="subheader">{item?.message || '-'}</Grid>
                          <Grid item sm={3} xs={12} className="subheader-3">Product details</Grid>
                          <Grid item sm={9} xs={12} container>
                            <Grid item md={1.2} sm={2} xs={4} className="d-flex">
                              <img src={item?.thumbnail || Helpers.noImageLink} alt="product-image" style={{ height: 56, width: '80%', objectFit: "contain" }} />
                            </Grid>
                            <Grid item md={10.8} sm={10} xs={8}>
                              {renderProductLabel(item?.product_name, item?.sku, { skuPrefix: 'SKU: ' })}
                              <Grid container mt={2}>
                                <Grid item sm={4} xs={6} className="subheader-2 font-size-12 d-flex align-items">Refund qty</Grid>
                                <Grid item sm={8} xs={6}>{item?.quantity || '0'}</Grid>
                                <Grid item sm={4} xs={6} className="subheader-2 font-size-12">Refund amount</Grid>
                                <Grid item sm={8} xs={6}>S$ {(item?.return_preference === 'refund ' || item?.return_preference === 'store_credit') ? item?.return_amount || '0.00' : '-'}</Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item sm={3} xs={12} className="subheader-3">Reason for return:</Grid>
                          <Grid item sm={9} xs={12} className="subheader">
                            <div className="text-bold">{item?.reason_for_return || '-'}</div>
                            {/* <div className="text-semibold">{'I purchased the ThinkPad laptop expecting it to have the pre-installed software as specified, but the software was missing. Additionally, the keyboard does not function correctly; certain keys are unresponsive.'}</div> */}
                          </Grid>
                          <Grid item sm={3} xs={12} className="subheader-3">Condition of the product:</Grid>
                          <Grid item sm={9} xs={12}>
                            <div className="text-bold">
                              {
                                item?.product_condition?.length > 1 ?
                                  <ol className="p-0 px-3">
                                    {
                                      item?.product_condition?.map((condition, idx) => {
                                        return (
                                          <li>{condition}</li>
                                        )
                                      })
                                    }
                                  </ol> : '-'
                              }

                            </div>
                            <div className="text-Semibold">{item?.other_product_condition || ''}</div>
                          </Grid>
                          <Grid item sm={3} xs={12} className="subheader-3">Attachment</Grid>
                          <Grid item sm={9} xs={12} className="subheader">
                            {
                              item?.attachments?.length > 0 && item?.attachments.map((attachment, idx) => {
                                return (
                                  <img src={attachment?.url} alt="product-image" style={{ height: 96, width: 120, objectFit: "contain", marginRight: 10 }} />
                                )
                              })
                            }
                          </Grid>
                          <Grid item sm={12} xs={12}><Divider /></Grid>
                        </Grid>
                      )
                    })
                  }
                  {/* end loop returned item */}
                </Grid>
              </CardBody>
            </Card>
          }
          <Card className="p-3 mt-4">
            <CardBody>
              <div className="header-2">Remarks</div>
              <Divider className="my-3" />
              <Table
                header={header}
                data={orderDetailData?.logs ? orderDetailData.logs.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at) }) : []}
                pageSize={(orderDetailData?.logs?.length > 0 && orderDetailData?.logs?.length) || 10}
                totalPage={1}
                customToolsBar={true}
              />
              <div className="mt-2">
                <CustomTextField
                  values={remark}
                  onChange={setRemark}
                  multiline={true}
                  rows={4}
                />
                {/* <CheckBox
                  label={'Show Remark On Purchase Order + Front End Customer Profile Page'}
                  values={showRemarkOnFrontend}
                  onChange={(e) => setShowRemarkOnFrondend(e.target.checked)}
                /> */}
              </div>
              <div className="">
                <CustomButton
                  title={'Add Remark'}
                  press={() => handleAddRemark()}
                  backgroundColor={'#101010'}
                  textColor={'white'}
                />
              </div>
            </CardBody>
          </Card>
        </Container>
        <AppDialog
          title={'Mark as ready for pickup'}
          titleIcon={'complete'}
          open={readyPickupOpen}
          close={() => setReadyPickupOpen(false)}
          positiveTitle={'Confirm'}
          positivePress={() => handleMarkOrderAsReadyForPickup()}
          negativePress={() => setReadyPickupOpen(false)}
          negativeTitle={'Cancel'}
          width={'40%'}
        >
          <div >Are you sure to confirm to set the order status to "Ready for pickup".</div>
        </AppDialog>
        <CollectPayment
          open={collectPaymentOpen}
          close={() => setCollectPaymentOpen(false)}
          paymentList={paymentTypeList || []}
          submit={(payload) => handleMarkOrderAsPaid(payload)}
        />
        <CancelOrder
          open={cancelOrderOpen}
          close={() => setCancelOrderOpen(false)}
          earnedPointsGiven={orderDetailData?.earned_points_given || 0}
          submit={(payload) => handleCancelOrder(payload)}
        />
        <InsufficientPointsCancel
          open={insufficientPointsOpen}
          close={() => {
            setInsufficientPointsOpen(false);
            setPendingCancelReason('');
          }}
          pointsRequired={insufficientPointsInfo.pointsRequired}
          pointsAvailable={insufficientPointsInfo.pointsAvailable}
          submit={() => handleForceCancelWithoutPoints()}
        />
        <ReopenOrder
          open={reopenOrderOpen}
          close={() => setReopenOrderOpen(false)}
          submit={() => handleReopenOrder()}
        />
        <UnpaidOrder
          open={unpaidOrderOpen}
          close={() => setUnpaidOrderOpen(false)}
          submit={() => handleUnpaidOrder()}
        />
        <RevertOrder
          open={revertStatusOpen}
          close={() => setRevertStatusOpen(false)}
          status={orderDetailData?.status}
          submit={(payload) => handleRevertOrder(payload)}
        />
        <DeleteOrder
          open={deleteOrderOpen}
          close={() => setDeleteOrderOpen(false)}
          submit={() => handleDeleteOrder()}
        />
        <ShippedOrder
          open={markShippedOpen}
          close={() => setMarkShippedOpen(false)}
          courierList={courier_list}
          orderData={orderDetailData}
          shippingMethodList={shippingMethodList}
          submit={(payload) => handleMarkAsShipped(payload)}
        />
        <EditShippedOrder
          open={editShippingOpen}
          close={() => setEditShippingOpen(false)}
          orderData={orderDetailData}
          shippingMethodList={shippingMethodList}
          courierList={courier_list}
          submit={(payload) => handleEditShippingDetails(payload)}
        />
        <RefundOrder
          open={refundOpen}
          close={() => setRefundOpen(false)}
          refundData={orderDetailData?.items || []}
          pointsEnabled={orderDetails?.points_enabled !== false}
          submit={(payload) => handleRefund(payload)}
        />
        <DeliverOrder
          open={markDeliveredOpen}
          close={() => setMarkDelieveredOpen(false)}
          submit={() => handleMarkAsDelivered()}
        />
        <CloseOrder
          open={markClosedOpen}
          close={() => setMarkClosedOpen(false)}
          submit={() => handleMarkAsClose()}
        />
      </div>
    </React.Fragment >
  );
};

const header = [
  {
    Header: "Date",
    accessor: (cellProps) => {
      return (
        <React.Fragment>
          <div>{(cellProps?.created_at && moment(cellProps?.created_at).format("DD MMM YYYY, hh:mm A")) || '-'}</div>
        </React.Fragment>
      )
    },
    minWidth: 200,
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Status",
    accessor: (cellProps) => {
      return (<React.Fragment><Label.OrderLabel label={cellProps.status} marginLeft={"0px"} /></React.Fragment>)
    },
    minWidth: 200,
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Remark",
    accessor: (cellProps) => {
      return (<React.Fragment>{cellProps?.remark || '-'}</React.Fragment>)
    },
    minWidth: 350,
    disableFilters: true,
    filterable: false,
  },
  {
    Header: "Action",
    accessor: (cellProps) => {
      return (<React.Fragment>{cellProps?.action}</React.Fragment>)
    },
    disableFilters: true,
    filterable: false,
  },
]

const RenderActionButton = ({ title, setOpen }) => {
  return (
    title &&
    <CustomButton
      title={title}
      backgroundColor={'#101010'}
      textColor={'white'}
      marginRight={10}
      press={() => setOpen(true)}
    />
  )
}


const RenderOptionsButton = ({ dropdownList }) => {
  return (
    dropdownList &&
    <CustomDropDown
      toggle={<i className="ri-more-fill" style={{ color: '#999999' }} />}
      items={dropdownList}
    />
  )
}

function mapStateToProps({ Login, Order, General }) {
  const courier_list = General.courier_list && Object.entries(General.courier_list).map(([key, value]) => ({
    label: value,
    value: key
  }));
  const shippingMethodList = General.shipping_methods?.length > 0 ? General.shipping_methods?.filter((item) => item?.status === 1) : [];
  return {
    userPermission: Login.permissionArry,
    orderDetails: Order?.orderDetails,
    configurationsList: General.configurations,
    shippingMethodList: shippingMethodList,
    productsList: General.products,
    courier_list: courier_list,
    paymentTypeList: General.payment_type,
    countryList: General.countries,
    insertLog: Order.insertLogOrder,
    updateCustomer: Order.updateCustomerDetails,
    updateShipping: Order.updateShippingDetails,
    updateBilling: Order.updateBillingDetails,
    markAsPaid: Order.markOrderAsPaid,
    orderDelete: Order.deleteOrder,
    orderUpdateStatus: Order.updateOrderStatus,
    orderUpdateCourier: Order.updateOrderCourier,
    orderRevertStatus: Order.revertOrderStatus,
    invoiceDocument: Order.invoiceDocument
  };
}

export default connect(mapStateToProps)(ViewOrderAspeed);